import { render, staticRenderFns } from "./CrmSettings.vue?vue&type=template&id=5957c082&scoped=true&"
import script from "./CrmSettings.vue?vue&type=script&lang=js&"
export * from "./CrmSettings.vue?vue&type=script&lang=js&"
import style0 from "./CrmSettings.vue?vue&type=style&index=0&id=5957c082&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5957c082",
  null
  
)

export default component.exports